import { useCallback } from 'react'
import type { ShapeData } from '@/lib/shapes/types/shape-data'
import {
  isShapeFrozenForGeometry,
  isShapeLockedForUserEdit,
} from '@/lib/groups/element-edit-policy'
import type { ShapeManagerStateApi } from './use-shape-manager-state'
import type { SelectionPresentationApi } from './use-selection-presentation'

export function useFeedbackPulses(ctx: ShapeManagerStateApi & SelectionPresentationApi) {
  const { setFrozenOutlinePulse, setGeometryBlockedPulseKey, shapesById } = ctx

  const triggerSelectionChromeBlockedPulse = useCallback(() => {
    setGeometryBlockedPulseKey((k) => k + 1)
  }, [setGeometryBlockedPulseKey])

  const triggerFrozenGeometryBlockedPulse = useCallback(
    (shape: ShapeData) => {
      if (
        isShapeFrozenForGeometry(shape, shapesById) &&
        !isShapeLockedForUserEdit(shape, shapesById)
      ) {
        triggerSelectionChromeBlockedPulse()
      }
    },
    [shapesById, triggerSelectionChromeBlockedPulse]
  )

  const triggerFrozenObjectOutlinePulse = useCallback(
    (shapeId: string) => {
      setFrozenOutlinePulse({ shapeId, key: Date.now() })
    },
    [setFrozenOutlinePulse]
  )

  return {
    triggerSelectionChromeBlockedPulse,
    triggerFrozenGeometryBlockedPulse,
    triggerFrozenObjectOutlinePulse,
  }
}

export type FeedbackPulsesApi = ReturnType<typeof useFeedbackPulses>
